import { Tabs } from "antd";
import { Component } from 'react';
import { connect } from "react-redux";
import { getParamsFromUrl } from "../../util/library/Router";
import { AppState } from "../../util/store/store";
import { VESSEL_DEVICE_TYPE_NAME } from "../../util/varibles/constants";
import { ACTION } from '../../util/varibles/permission';
import { SOCKET_FUNC, SOCKET_NAME } from "../../web-socket/constants";
import WSService from "../../web-socket/web-socket-service";
import Title from "./_component/Title";
import ActivityLog from "./ActivityLog";
import Configuration from "./Configuration";
import Detail from "./Detail";
import ProcessData from "./ProcessData";
import { vesselDetailActions } from "./reducer";
import styles from './style.module.scss';

enum VIEW_TYPE {
    DETAIL = 'detail',
    GRAPH = 'graph',
    ACTIVITY_LOG = 'activityLog',
    CONFIG = 'config',
}


const mapStateToProps = (state: AppState) => ({
    permission: state.login.user.permission,
});

interface IProps {
    permission: any

    updateLocation(payload: any): void

    getVessel(args: { id: string, callback: Function }): void

    getDashboards(payload: string): void

    addGps(payload: number): void
}

class VesselDetailPage extends Component<IProps> {
    groups: string[] = [];
    interval: any;
    timeout: any;
    id = '';
    private isActive = false;
    private socketTimer?: ReturnType<typeof setTimeout>;

    componentDidMount() {
        this.isActive = true;
        const { id = '' } = getParamsFromUrl();
        this.id = id;
        this.props.getVessel({
            id,
            callback: () => {
                if (!this.isActive) return;
                this.socketTimer = setTimeout(this.registerWebSocket, 300);
            }
        });
        this.props.getDashboards(this.id);
        const newTime = (Math.floor(Date.now() / 300000) + 1) * 300000;
        this.timeout = setTimeout(() => {
            this.props.addGps(Date.now());
            this.interval = setInterval(() => this.props.addGps(Date.now()), 300000)
        }, newTime - Date.now())
    }

    componentWillUnmount() {
        this.isActive = false;
        clearTimeout(this.socketTimer);
        clearInterval(this.interval);
        clearTimeout(this.timeout);
        WSService.close(SOCKET_NAME.PAGE, this.groups)
    }

    registerWebSocket = () => {
        if (!this.isActive) return;
        this.groups = [this.id + "-" + VESSEL_DEVICE_TYPE_NAME.LOCATION, this.id + "-" + VESSEL_DEVICE_TYPE_NAME.SENSORS];
        new WSService({
            groups: this.groups,
            listener: {
                lev: SOCKET_NAME.PAGE,
                func: (value: any) => this.processMessage(value)
            }
        });
    }

    processMessage = (value: any) => {
        if (value.function === SOCKET_FUNC.VESSEL_GPS && value.vessel_id && value.vessel_id === this.id) {
            this.props.updateLocation(value);
        }
    }

    render() {
        const { permission } = this.props;
        return <div className="m-header bgPage">
            <Tabs
                defaultActiveKey={VIEW_TYPE.DETAIL}
                centered
                rootClassName={styles.page}
                tabBarExtraContent={{
                    left: <Title />,
                }}
                renderTabBar={(props, DefaultTabBar) => <DefaultTabBar className='h-[56px]' {...props} />}
                tabBarGutter={10}
                items={[
                    {
                        label: `Vessel info.`,
                        key: VIEW_TYPE.DETAIL,
                        children: <Detail />
                    },
                    {
                        label: `Process data`,
                        key: VIEW_TYPE.GRAPH,
                        children: <ProcessData />
                    },
                    {
                        label: `Activity log`,
                        key: VIEW_TYPE.ACTIVITY_LOG,
                        children: <ActivityLog vesselId={this.id} />
                    },
                    ...(permission[ACTION.VESSEL.CONFIGURATION] ? [{
                        label: `Configuration`,
                        key: VIEW_TYPE.CONFIG,
                        children: <Configuration />
                    }] : []),
                ]}
            />
        </div>;
    }
}

export default connect(mapStateToProps, {
    updateLocation: vesselDetailActions.updateLocation,
    getVessel: vesselDetailActions.getVesselRequest,
    getDashboards: vesselDetailActions.getDashboardsRequest,
    addGps: vesselDetailActions.addGps,
})(VesselDetailPage)
